import { Component, computed, effect, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CardItem } from '@components/partials/card-item/card-item';
import { HeroBinder } from '@components/partials/hero-binder/hero-binder';
import { PageItem } from '@components/partials/page-item/page-item';
import { UiModule } from '@components/ui/ui-module';
import { Binder, CardBinder, Page, Scan, UserBinder } from '@models/binder.model';
import { Card } from '@models/card.model';
import { BinderService } from '@services/binder.service';
import { Global } from '@services/global.service';
import { Router } from '@services/route.service';
import { SettingService } from '@services/setting.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'lgb-favorite-list',
  imports: [
    UiModule,
    RouterModule,
    FormsModule,
    HeroBinder,
    PageItem,
    CardItem
  ],
  templateUrl: './favorite-list.html',
  styleUrl: './favorite-list.css',
})
export class FavoriteList {
  //services
  readonly router=inject(Router);
  readonly binderS=inject(BinderService);
  readonly globalS=inject(Global);
  readonly settings=inject(SettingService);

  //data
  readonly binders=signal<Binder[]>([]);
  readonly uBinders=signal<UserBinder[]>([]);
  readonly pages=signal<Page[]>([]);
  readonly cardBinder=signal<CardBinder[]>([]);
  readonly references=signal<Card[]>([]);
  readonly scans=signal<Scan[]>([]);
  readonly favoris=computed(() => {
    let result: (CardBinder|UserBinder|Page)[]=[];
    result=[...this.uBinders().map(b => Object.assign(new UserBinder(), b))];
    result=[...result, ...this.pages().map(p => Object.assign(new Page(), p))];
    result=[...result, ...this.cardBinder().map(c => Object.assign(new CardBinder(), c))];

    return result.sort((a: any, b: any) => a.isFavorite-b.isFavorite);
  });

  //ui
  readonly loading=signal(false);

  constructor(){
    this.loading.set(true);

    forkJoin({
      binders: this.binderS.getBinders(),
      favoris: this.binderS.getFavorites()
    })
    .subscribe(response => {
      this.binders.set(response.binders);
      this.scans.set(response.favoris.scans);
      this.uBinders.set(response.favoris.binders);
      this.pages.set(response.favoris.pages);
      this.cardBinder.set(response.favoris.cardBinder);
      this.references.set(response.favoris.references);
      this.loading.set(false);
    });
  }

  isUserBinder(item: CardBinder|UserBinder|Page){
    return item instanceof UserBinder;
  }

  isPage(item: CardBinder|UserBinder|Page){
    return item instanceof Page;
  }

  isCardBinder(item: CardBinder|UserBinder|Page){
    return item instanceof CardBinder;
  }

  getBinder(uBinder: UserBinder){
    return this.binders().find(b => b.ident==uBinder.binder);
  }

  getScan(ident: string){
    return this.scans().find(s => s.ident==ident);
  }

  getRefence(ident: string){
    return this.references().find(r => r.ident==ident);
  }

  unlikeBinder(ident: string){
    this.uBinders.update(val => {
      val.splice(val.findIndex(b => b.ident==ident), 1);
      return [...val];
    });
  }

  unlikePage(ident: string){
    this.pages.update(val => {
      val.splice(val.findIndex(b => b.ident==ident), 1);
      return [...val];
    });
  }

  unlikeCard(ident: string){
    this.cardBinder.update(val => {
      val.splice(val.findIndex(b => b.ident==ident), 1);
      return [...val];
    });
  }
}
